import React from 'react'
import './DiscriptionBox.css'

 const DiscriptionBox = () => {
  return (
    <div className='discriptionbox'>
        <div className="descriptionbox-navigator">
            <div className="descriptionbox-nav-box">Discription</div>
            <div className="descriptionbox-nav-box fade">Reviews (122)</div>
        </div>
        <div className="descriptionbox-description">
            <p>An e-commerce website is an online plateform that facilitate
                buying and selling of products or services over the internet 
                serves as a virtual mardketplace where businesses and individual
                showcase their products, interact with customers, and conduct
                transactions without the need for a physical presence. E-commerce websitees have gained immense popularity due to their convenince
                accessibility, and the global reach they offer.</p>
        </div>
    </div>
  )
}

export default DiscriptionBox;
